export default __webpack_public_path__ + "static/O0243-f6071b90d6cad049de3165ffa0eda3af.png";